import React from 'react';
import { StyleSheet, Text, View, Image } from 'react-native';

import IMAGES from 'shared/constants/images';
import Button from 'shared/modules/common/components/atoms/Button';
import generateID from 'shared/modules/common/utils/generate-id';

type Props = {
  errorType?: 'timeout' | 'notice' | 'authError';
  onErrorCloseButtonPress: (isTryAgain: boolean) => void;
};

const ERROR_TYPES = {
  timeout: {
    title: 'もう一度お試しください',
    body:
      '制限時間内に入力が完了しませんでした。\nお手数ですが、もう一度はじめから\nお試しください。',
    isTryAgain: true,
  },
  notice: {
    title: '時間をおいてから\n再度お試しください。',
    body:
      'メールアドレスの確認は、\n一度行うと24時間以内は行えません。\n時間をおいてから再度お試しください。',
    isTryAgain: false,
  },
  authError: {
    title: '認証エラー',
    body: 'お手数ですが、再度お手続きを\nお願いいたします。',
    isTryAgain: true,
  },
};

const EmailReminderPhoneError = (props: Props) => {
  if (props.errorType) {
    return (
      <View
        style={style.container}
        {...generateID('step4-email-reminder-dialog')}
      >
        <View style={style.topSectionCenter}>
          <Image source={IMAGES.exclaimTriangle} style={style.errorImage} />
          <Text style={[style.title, style.textCenter]}>
            {ERROR_TYPES[props.errorType].title}
          </Text>
          <Text style={[style.body, style.textCenter]}>
            {ERROR_TYPES[props.errorType].body}
          </Text>
        </View>
        <View style={style.buttonContainer}>
          <Button
            title={
              ERROR_TYPES[props.errorType].isTryAgain
                ? 'もう一度試す'
                : '閉じる'
            }
            onPress={() => {
              props.errorType &&
                props.onErrorCloseButtonPress(
                  ERROR_TYPES[props.errorType].isTryAgain
                );
            }}
            style={style.button}
            id="close-email-reminder-dialog"
          />
        </View>
      </View>
    );
  } else {
    return null;
  }
};

const style = StyleSheet.create({
  container: {
    flex: 1,
  },
  topSectionCenter: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: '600',
    color: '#2a2e32',
    marginBottom: 24,
  },
  textCenter: {
    alignSelf: 'center',
    textAlign: 'center',
  },
  button: {
    alignSelf: 'center',
    marginVertical: 8,
  },
  body: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '300',
    color: '#2a2e32',
    marginBottom: 24,
  },
  buttonContainer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  errorImage: {
    width: 184,
    height: 184,
    alignSelf: 'center',
  },
});

export default EmailReminderPhoneError;
